import { render, staticRenderFns } from "./import-physicalmodel.vue?vue&type=template&id=51422177&scoped=true"
import script from "./import-physicalmodel.vue?vue&type=script&lang=js"
export * from "./import-physicalmodel.vue?vue&type=script&lang=js"
import style0 from "./import-physicalmodel.vue?vue&type=style&index=0&id=51422177&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51422177",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\GitWorkplace\\物联网\\tenda_iot_system\\node_modules\\_vue-hot-reload-api@2.3.4@vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('51422177')) {
      api.createRecord('51422177', component.options)
    } else {
      api.reload('51422177', component.options)
    }
    module.hot.accept("./import-physicalmodel.vue?vue&type=template&id=51422177&scoped=true", function () {
      api.rerender('51422177', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/product/physicalmodel/import-physicalmodel.vue"
export default component.exports